export default "__VITE_ASSET__CrjRpH5v__"